import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

export interface ITabCard {
  text: string
  isSelected: boolean
  setSelected: () => void
}

export const TabCard = ({ text, isSelected, setSelected }: ITabCard) => {
  if (isSelected) {
    return (
      <Box
        border={{
          bottom: {
            color: 'grey1000',
            width: 's2',
            style: 'solid',
          },
        }}
        padding="s1"
        paddingY="s12"
        cursor="pointer"
        flexDirection="row"
        alignItems="center"
        gap="s8"
      >
        <Text.Normal>{text}</Text.Normal>
      </Box>
    )
  }

  return (
    <Box
      padding="s1"
      paddingY="s12"
      onClick={setSelected}
      cursor="pointer"
      flexDirection="row"
      alignItems="center"
      gap="s12"
    >
      <Text.Normal>{text}</Text.Normal>
    </Box>
  )
}
